/* eslint-disable */
import request from '@/utils/serviceXAuthTokenFormUrlencKey'

import { APICoreV2 } from '@/utils/servicesApi'

export function isOnline(phone) {
  return request({
    url: APICoreV2() + '/public/whatsapp/is_online_v2?phonex=' + phone,
    method: 'POST',
  })
}


// WEBPACK FOOTER //
// ./src/api/omniwa.js